import "./App.css";
import { useEffect } from "react";
import { EntryPage } from "./components/pages/Entry/EntryPage.js";
import { TradingPage } from "./components/pages/Trading/TradingPage.js";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    useLocation,
} from "react-router-dom";
import { VerificationPage } from "./components/pages/Verification/VerificationPage.js";
import { ContactDetailPage } from "./components/pages/ContactDetail/ContactDetailPage.js";
import { CompanyDetailPage } from "./components/pages/CompanyDetail/CompanyDetailPage.js";
import { ThankyouPage } from "./components/pages/Thankyou/ThankyouPage";
import { ContinueLaterPage } from "./components/pages/ContinueLater/ContinueLaterPage.js";
import { PayrollTermAndConditionPage } from "./components/pages/PayrollTermAndCondition/PayrollTermAndConditionPage.js";
import { PaymentInformationPage } from "./components/pages/Payment/PaymentInformationPage.js";
import { ReviewPage } from "./components/pages/Review/ReviewPage.js";

function App() {
    const ScrollToTop = () => {
        const location = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [location]);
        return null;
    };
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route
                    path="/"
                    element={<EntryPage />}
                />
                <Route
                    path="/verification"
                    element={<VerificationPage />}
                />
                <Route
                    path="/companyDetail"
                    element={<CompanyDetailPage />}
                />
                <Route
                    path="/trading"
                    element={<TradingPage />}
                />
                <Route
                    path="/contactDetail"
                    element={<ContactDetailPage />}
                />
                <Route
                    path="/payrollTerms"
                    element={<PayrollTermAndConditionPage />}
                />
                <Route
                    path="/paymentInfo"
                    element={<PaymentInformationPage />}
                />
                <Route
                    path="/review"
                    element={<ReviewPage />}
                />
                <Route
                    path="/thankyou"
                    element={<ThankyouPage />}
                />
                <Route
                    path="/continueLater"
                    element={<ContinueLaterPage />}
                />
            </Routes>
        </Router>
    );
}

export default App;
